;(function() {
    var


    //
    //init
    //
    init = function() {
        if ($('.layout-create-account').length > 0) {
            showTextAreas();

            setupRadios();

            setupRequired();
        }
    },

    //
    // setup the radio button handlers to show/hide the text areas
    //
    setupRadios = function() {
        $('.referral').click(function() {
            showTextAreas();
        });
    },

    //
    // show or hide the text areas
    //
    showTextAreas = function() {
        //get the selected radio value
        var v = $('.referral:checked').val();

        //hide all text areas
        $('.please-describe').hide();

        //show the appropriate text area
        if (v) {
            $('.please-describe').filter('[data-for="' + v + '"]').show();
        }
    },

    //
    // Add * to beginning of required field captions
    //
    setupRequired = function() {
        $('.required').each(function() {
            $(this).html("* " + $(this).html());
        });
    };


    //call init
    $(document).ready(init);

})();